<p-tabView>

  <!-- ── TAB 1: CELDA ───────────────────────────────────────────── -->
  <p-tabPanel header="{{ 'CELL.TAB_CELL' | translate }}">
    <div class="dialog-section">

      <!-- Selector de modelo -->
      <div class="field-row" *ngIf="models.length > 0">
        <label class="field-label">{{ 'PRODUCT.SELECT_MODEL' | translate }}</label>
        <p-dropdown
          [options]="models"
          [(ngModel)]="selectedModel"
          [showClear]="true"
          placeholder="{{ 'PRODUCT.SELECT_MODEL' | translate }}"
          styleClass="w-full"
        ></p-dropdown>
      </div>

      <!-- Campos extra -->
      <div *ngIf="extraFields.length > 0">
        <p class="section-title">{{ 'PRODUCT.EXTRA_FIELDS' | translate }}</p>
        <div class="extra-fields-grid">
          <div class="extra-field-item" *ngFor="let extra of extraFields">
            <label class="field-label">{{ extra.label }}</label>
            <input pInputText [(ngModel)]="extra.value" class="w-full" />
          </div>
        </div>
      </div>

      <p-divider></p-divider>

      <!-- Notas -->
      <div class="field-row">
        <label class="field-label">{{ 'CELL.ADD_NOTES' | translate }}</label>
        <textarea
          pInputTextarea
          [(ngModel)]="notes"
          rows="3"
          class="w-full"
          autoResize="true"
        ></textarea>
      </div>

      <!-- Info técnica residual -->
      <div class="tech-info">
        <span>id:{{ pageCell?.id }}</span>
        <span>fasc:{{ idFascicle }}</span>
        <span>cat:{{ idCatalog }}</span>
      </div>
    </div>

    <!-- Botones -->
    <div class="dialog-footer">
      <p-button
        label="{{ 'NOTES.DELETE' | translate }}"
        icon="pi pi-trash"
        severity="danger"
        [outlined]="true"
        [disabled]="!notes"
        (onClick)="deleteNote()"
      ></p-button>
      <div class="flex gap-2">
        <p-button
          label="{{ 'FORM.CANCEL' | translate }}"
          icon="pi pi-times"
          severity="secondary"
          [outlined]="true"
          (onClick)="cancel()"
        ></p-button>
        <p-button
          label="{{ 'FORM.SAVE' | translate }}"
          icon="pi pi-check"
          severity="success"
          [loading]="saving"
          (onClick)="save()"
        ></p-button>
      </div>
    </div>
  </p-tabPanel>

  <!-- ── TAB 2: PRODUCTO ────────────────────────────────────────── -->
  <p-tabPanel header="{{ 'PRODUCT.PRODUCT' | translate }}">
    <div class="product-tab" *ngIf="product">

      <div class="product-image-wrap" *ngIf="product.img">
        <img [src]="product.img" [alt]="product.name" class="product-img" />
      </div>

      <table class="details-table">
        <tbody>
          <tr class="details-row">
            <td class="label">{{ 'PRODUCT.SKU' | translate }}</td>
            <td class="value">{{ product.sku }}</td>
          </tr>
          <tr class="details-row">
            <td class="label">{{ 'NAME' | translate }}</td>
            <td class="value">{{ product.name }}</td>
          </tr>
          <tr class="details-row" *ngIf="product.description">
            <td class="label">{{ 'DESCRIPTION' | translate }}</td>
            <td class="value">{{ product.description }}</td>
          </tr>
          <tr class="details-row" *ngIf="product.family">
            <td class="label">{{ 'PRODUCT.FAMILY' | translate }}</td>
            <td class="value">{{ product.family }}</td>
          </tr>
          <tr class="details-row" *ngIf="product.createdAt">
            <td class="label">{{ 'CREATED_AT' | translate }}</td>
            <td class="value">{{ product.createdAt | date: 'dd/MM/yyyy - HH:mm' }}</td>
          </tr>
          <tr class="details-row" *ngIf="product.tags?.length > 0">
            <td class="label">{{ 'TAGS' | translate }}</td>
            <td class="value">
              <p-tag *ngFor="let tag of product.tags" severity="info" styleClass="mr-1">{{ tag }}</p-tag>
            </td>
          </tr>
          <ng-container *ngFor="let field of product.extraFields | keyvalue">
            <tr class="details-row"
                *ngIf="field.key !== 'parent_category' && field.key !== 'estatus'">
              <td class="label">{{ field.key | titlecase }}</td>
              <td class="value">{{ field.value }}</td>
            </tr>
          </ng-container>
        </tbody>
      </table>
    </div>
  </p-tabPanel>

</p-tabView>
